import RespImage from '@/app/_components/core/resp-image';
import { SmartVideo } from '@/app/_components/core/smart-video';
import { transformSrcsetCandidates } from '@/app/_lib/image-art-direction';
import { emptyToUndefined } from '@/app/_lib/utils';
import { buildSimpleVideoSizes } from '@/app/_lib/video-utils';
import type { BaseImage, BaseVideoFile } from '@/entities/models/page';

// Form 2-cols media aspect ratio (4:5 portrait, no art direction)
const VIDEO_ASPECT = { width: 744, height: 930 };

interface MediaBlockProps {
  image?: BaseImage;
  video?: BaseVideoFile[];
  priority?: boolean;
}

export function MediaBlock({ image, video, priority }: MediaBlockProps) {
  const { srcsetCandidates } = image
    ? transformSrcsetCandidates(image.srcsetCandidates)
    : { srcsetCandidates: [] };
  const hasImage = srcsetCandidates.length > 0;
  const hasVideo = video && video.length > 0;

  if (!hasImage && !hasVideo) {
    return null;
  }

  const autoPlay = video?.[0]?.autoplay ?? true;

  return (
    <div className="relative aspect-4/5 size-full  overflow-hidden lg:rounded-form-embed-media after:pointer-events-none after:absolute after:inset-0 after:bg-overlay-dark">
      {hasVideo ? (
        <SmartVideo
          videoProps={{
            className: 'h-full w-full dark bg-background object-cover',
            autoPlay,
            muted: autoPlay,
            loop: true,
            playsInline: true,
            controls: !autoPlay,
          }}
          pictureProps={{ className: 'h-full w-full' }}
          imgProps={{ alt: '', className: 'h-full w-full object-cover' }}
          sizes={buildSimpleVideoSizes(video, VIDEO_ASPECT)}
        />
      ) : hasImage ? (
        <RespImage
          srcsetCandidates={srcsetCandidates}
          alt={image?.altText ?? ''}
          title={emptyToUndefined(image?.title)}
          sizes="(min-width: 1920px) 712px, (min-width: 1280px) 584px, (min-width: 1024px) 464px, (min-width: 768px) 736px, (min-width: 640px) 608px, 100vw"
          priority={priority}
          className="size-full  object-cover"
          loading="lazy"
        />
      ) : null}
    </div>
  );
}
